import { render } from "./QuestionsList.vue?vue&type=template&id=a1f5c31a&scoped=true"
import script from "./QuestionsList.vue?vue&type=script&lang=js"
export * from "./QuestionsList.vue?vue&type=script&lang=js"

import "./QuestionsList.vue?vue&type=style&index=0&id=a1f5c31a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f5c31a"]])

export default __exports__